import validator from 'validator';
import LanguageElementsHandler from '../../languageElementsHandler/LanguageElementsHandler';
import { languageElements as validatorLanguageElements } from './validators-languageElements';

const languageElementsHandler = new LanguageElementsHandler(validatorLanguageElements);

export const validators = {
    roundDigitOk(value, digit) {
        const numericValue = parseFloat(value);

        switch (digit) {
            case 0:
                return (validator.isInt(value.toString()));

            case 2:
                return (Math.abs(numericValue - Math.round(100 * numericValue) / 100) < 0.000001)

            case 3:
                return (Math.abs(numericValue - Math.round(1000 * numericValue) / 1000) < 0.000001)

            case 4:
                return (Math.abs(numericValue - Math.round(10000 * numericValue) / 10000) < 0.000001)

            default:
                return false;
        }
    },

    validateFloat(value, numberOfDigits, errorText) {
        if (value === null || value === undefined) {
            return '';
        }
        if (value.toString().length === 0) {
            return '';
        }
        if (!validator.isNumeric(value.toString())) {
            return errorText;
        }
        const numericValue = parseFloat(value);
        if (numericValue < 0) {
            return errorText;
        }

        if (!this.roundDigitOk(value, numberOfDigits)) {
            return errorText;
        }
        return '';
    },

    validateRegex(value, regexExpression, length, errorText) {
        if (!value) {
            return '';
        }

        if (length) {
            if (value.length !== length) {
                return errorText;
            }
        }

        return (regexExpression.test(value)) ? '' : errorText;
    },

    validate(field, typeOfValidation, value, language, fpStates) {
        if (typeof typeOfValidation === 'function') {
            return typeOfValidation(field, value, fpStates);
        } else {
            languageElementsHandler.setLanguage(language);
            const errorText = languageElementsHandler.get(typeOfValidation);

            switch (typeOfValidation) {
                case 'idRequired':
                    if (!value) {
                        return '';
                    }

                    const id = fpStates.fieldValues[`${field.name}_ID`];

                    if (id === null || id === undefined) {
                        return errorText;
                    }
                    switch (typeof (id)) {
                        case 'number':
                            return '';

                        default:
                            return (validator.isEmpty(id)) ? errorText : '';
                    }

                case 'valueAndId':
                    if (!value) {
                        return ''
                    }
                    return this.validate(field, 'idRequired', value, language, fpStates);

                case 'required':
                    if (value === null || value === undefined) {
                        return errorText;
                    }
                    switch (typeof (value)) {
                        case 'number':
                            return '';

                        case 'boolean':
                            return (!value) ? errorText : '';

                        default:
                            return (validator.isEmpty(value)) ? errorText : '';
                    }

                case 'mustAccept':
                    return (!value) ? errorText : '';

                case 'validEmail':
                    return (validator.isEmail(value)) ? '' : errorText;

                case 'validWagonNr':
                    return this.validateRegex(value, /\d\d\s\d\d\s\d\d\d\d\s\d\d\d-\d/, 16, errorText)

                case 'validContainerNr':
                    return this.validateRegex(value, /[a-zA-Z]{4}[0-9]{7}/, 11, errorText)

                case 'validContainerNr-pattern-2':
                    return this.validateRegex(value, /[a-zA-Z]{4} [0-9]{6}\-[0-9]{1}/, 13, errorText)

                case 'validStationsCode':
                    return this.validateRegex(value, /\d\d\ \d\d\d\d\d\d/, 9, errorText)

                case 'float2':
                    return this.validateFloat(value, 2, errorText)

                case 'float4':
                    return this.validateFloat(value, 4, errorText)

                case 'float':
                    return this.validateFloat(value, 3, errorText)

                case 'int':
                    return this.validateFloat(value, 0, errorText)

                case 'not_0':
                    if (value === null || value === undefined) {
                        return '';
                    }
                    if (validator.isFloat(value.toString())) {
                        if (Math.abs(parseFloat(value)) < 0.001) {
                            return errorText;
                        }
                    }
                    return '';

                default:
                    return `Unknown type of validation (${typeOfValidation})`;
            }
        }
    },

    getErrorText(typeOfValidation, language) {
        if (language) {
            languageElementsHandler.setLanguage(language);
        }
        return languageElementsHandler.get(typeOfValidation);
    }
}
